import React, { FC } from 'react';
import PropTypes from 'prop-types';
import styles from './Role.module.scss';

interface RoleProps {
	name: string;
	color: string;
	className?: string;
}

const Role: FC<RoleProps> = ({ name, color, className }) => {
	return (
		<div className={`${styles.Role} ${className ? className : ''}`}>
			<span className={styles.RoleColor} style={{ backgroundColor: color }}></span>
			<span className={styles.RoleName}>{name}</span>
		</div>
	);
};

Role.propTypes = {
	name: PropTypes.string.isRequired,
	color: PropTypes.string.isRequired,
	className: PropTypes.string,
};

export { Role };
